export class DashboardCalendarBase {
    public accepted_holidays: number
    public pending_holidays: number
    public accepted_personal_matters: number
    public pending_personal_matters: number
    public accepted_sick_leave: number
    public pending_sick_leave: number
    public accepted_paid_leave: number
    public pending_paid_leave: number
    public accepted_remote_work: number
    public pending_remote_work: number

    constructor() {
        this.accepted_holidays = 0
        this.pending_holidays = 0
        this.accepted_personal_matters = 0
        this.pending_personal_matters = 0
        this.accepted_sick_leave = 0
        this.pending_sick_leave = 0
        this.accepted_paid_leave = 0
        this.pending_paid_leave = 0
        this.accepted_remote_work = 0
        this.pending_remote_work = 0
    }
}

export class DashboardCalendarCount extends DashboardCalendarBase {
    public total_accepted: number
    public total_pending: number

    constructor() {
        super()

        this.total_accepted = 0
        this.total_pending = 0
    }
}

export class DashboardCalendarPencentage extends DashboardCalendarBase {
}

export class DashboardCalendarStats {
    public totals: DashboardCalendarCount
    public percentages: DashboardCalendarPencentage
}

export class DashboardCalendarChartBase {
    public totalHolidays: number
    public totalPersonalMatters: number
    public totalSickLeave: number
    public totalPaidLeave: number
    public totalRemoteWork: number

    constructor(
        totalHolidays: number,
        totalPersonalMatters: number,
        totalSickLeave: number,
        totalPaidLeave: number,
        totalRemoteWork: number
    ) {
        this.totalHolidays = totalHolidays
        this.totalPersonalMatters = totalPersonalMatters
        this.totalSickLeave = totalSickLeave
        this.totalPaidLeave = totalPaidLeave
        this.totalRemoteWork = totalRemoteWork
    }
}

export class DashboardCalendarChartCount extends DashboardCalendarChartBase {
    public totalCount: number

    constructor(
        totalHolidays: number,
        totalPersonalMatters: number,
        totalSickLeave: number,
        totalPaidLeave: number,
        totalRemoteWork: number,
        totalCount: number
    ) {
        super(totalHolidays, totalPersonalMatters, totalSickLeave, totalPaidLeave, totalRemoteWork)

        this.totalCount = totalCount
    }
}

export class DashboardCalendarChartPercentage extends DashboardCalendarChartBase {
}

export class DashboardCalendarChartStats {
    public totals: DashboardCalendarChartCount
    public percentages: DashboardCalendarChartPercentage
}

export class DashboardCalendarCountOfMonth {
    public accepted: number
    public pending: number
    public month: number
}

export class DashboardCalendarStatsOfMonths {
    public holidays: DashboardCalendarCountOfMonth[]
    public personal_matters: DashboardCalendarCountOfMonth[]
    public sick_leave: DashboardCalendarCountOfMonth[]
    public paid_leave: DashboardCalendarCountOfMonth[]
    public remote_work: DashboardCalendarCountOfMonth[]
}

export class DashboardCalendarChartCountOfMonth {
    public value: number
    public month: number
}

export class DashboardCalendarChartStatsOfMonths {
    public holidays: DashboardCalendarChartCountOfMonth[]
    public personalMatters: DashboardCalendarChartCountOfMonth[]
    public sickLeave: DashboardCalendarChartCountOfMonth[]
    public paidLeave: DashboardCalendarChartCountOfMonth[]
    public remoteWork: DashboardCalendarChartCountOfMonth[]
}

export enum DashboardCalendarOption {
    DAYS = 'days',
    EMPLOYEES = 'employees'
}
